/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hero_CtaInputs */

const en_hero_cta = /** @type {(inputs: Hero_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick a time`)
};

const pl_hero_cta = /** @type {(inputs: Hero_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wybierz termin`)
};

/**
* | output |
* | --- |
* | "Pick a time" |
*
* @param {Hero_CtaInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const hero_cta = /** @type {((inputs?: Hero_CtaInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hero_CtaInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_hero_cta(inputs)
	return en_hero_cta(inputs)
});